import React from 'react';

import getConfig from '../../util/config';

const IFrameTesting = () => {
  return (
    <div className="h-100vh w-100">
      <iframe
        title="Waldo"
        src={`${getConfig().app.baseUrl}/galleries/search`}
        width="100%"
        height="100%"
      />
    </div>
  );
};

export default IFrameTesting;
